'use client';

import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaXTwitter,
  FaGlobe,
} from "react-icons/fa6";
import { GoArrowUpRight } from "react-icons/go";

const logo = "/images/logo.svg";
const socialLinks = [
  {
    href: "https://www.facebook.com/profile.php?id=61571785329732",
    icon: FaFacebook,
    text: "Facebook",
    color: "group-hover/nested:text-[#1877F2]",
  },
  {
    href: "https://x.com/centeratech",
    icon: FaXTwitter,
    text: "Twitter",
    color: "group-hover/nested:text-[#AAB8C2]",
  },
  {
    href: "https://www.instagram.com/centera.tech",
    icon: FaInstagram,
    text: "Instagram",
    customIcon: (
      <svg
        className="w-6 h-6 transition-all duration-500 ease-in-out"
        viewBox="0 0 169 169"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="instagramGradient" x1="1" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#833AB4" />
            <stop offset="50%" stopColor="#C13584" />
            <stop offset="100%" stopColor="#ffbf1f" />
          </linearGradient>
        </defs>

        <g className="transition-all duration-500 ease-in-out">
          <g className="fill-white transition-all duration-500 group-hover/nested:opacity-0">
            <path
              d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
        c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
        c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
        c17.455,0,31.656,14.201,31.656,31.655V122.407z"
            />
            <path
              d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
        C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
        c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
            />
            <path
              d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
        c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
        C135.661,29.421,132.821,28.251,129.921,28.251z"
            />
          </g>

          <g className="fill-[url(#instagramGradient)] transition-all duration-500 opacity-0 group-hover/nested:opacity-100">
            <path
              d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
        c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
        c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
        c17.455,0,31.656,14.201,31.656,31.655V122.407z"
            />
            <path
              d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
        C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
        c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
            />
            <path
              d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
        c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
        C135.661,29.421,132.821,28.251,129.921,28.251z"
            />
          </g>
        </g>
      </svg>
    ),
  },
  {
    href: "https://www.youtube.com/@CenteraTech",
    icon: FaYoutube,
    text: "YouTube",
    color: "group-hover/nested:text-[#FF0000]",
  },
  {
    href: "https://www.linkedin.com/in/centera-tech-72ba35347",
    icon: FaLinkedin,
    text: "LinkedIn",
    color: "group-hover/nested:text-[#0A66C2]",
  },
  {
    href: "https://ranjitpasale.com/",
    icon: FaGlobe,
    text: "CEO - Ranjit Pasale",
    color: "group-hover/nested:text-[--accent-light]",
  },
];

const Links = () => {
  return (
    <div className="relative flex items-center justify-center">
      {/* Background Effects */}
      <div className="absolute inset-0 pointer-events-none z-30 opacity-50">
        <div className="mt-40 bg-cover bg-center bg-no-repeat opacity-60 h-[700px] bg-[url(/assets/grid-bg.svg)]" />
        <div className="absolute top-[500px] -left-20 -rotate-45 w-[600px] h-[400px] rounded-full bg-[radial-gradient(circle,var(--accent-dark),var(--accent-2-transparent-1))] blur-3xl opacity-5" />
        <div className="absolute top-[200px] -right-20 -rotate-45 w-[600px] h-[400px] rounded-full bg-[radial-gradient(circle,var(--accent-dark),var(--accent-2-transparent-1))] blur-3xl opacity-5" />
      </div>

      {/* Main Content */}
      <div className="w-full max-w-[1024px] px-4 md:px-6 lg:px-8 flex items-center justify-center mt-10">
        <div className="rounded-lg p-4 md:p-6 w-full flex flex-col items-center text-center">
          {/* Logo */}
          <img
            src={logo}
            alt="Centera Tech"
            className="w-20 h-20 md:w-28 md:h-28 mb-4 object-contain"
          />

          {/* Header */}
          <h1 className="text-xl md:text-2xl font-semibold mb-2">
            Centera Tech
          </h1>
          <p className="text-color-2 mb-6 md:mb-10 flex flex-col sm:flex-row gap-1">
            <span>Stay connected with Centera Tech</span>
            <span>- find us everywhere that matters.</span>
          </p>

          {/* Social Links */}
          <div className="flex flex-col gap-y-3">
            {socialLinks.map((link, index) => (
              <div className="relative h-full p-px rounded-full w-full overflow-hidden group">
                {/* Rotating gradient background */}
                <div
                  className={`absolute inset-0 rounded-full bg-[linear-gradient(155deg,var(--accent-light),#fff7_50%)] transition-transform duration-700 group-hover:rotate-180 blur-2xl scale-150`}
                ></div>

                {/* <div className="relative h-full flex flex-col flex-shrink-0 items-start gap-6 p-3 md:p-6 rounded-xl bg-color-98"> */}
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-72 sm:w-96 relative flex items-center gap-1 sm:gap-3 py-2 px-4 rounded-full bg-color-99 group/nested transition-all duration-300"
                >
                  {link.customIcon || (
                    <link.icon
                      className={`w-6 h-7 text-color-1 transition-all duration-300 
                        ${link.color || ""}
                      `}
                    />
                  )}
                  <div className="whitespace-nowrap text-color-1 text-base leading-[normal] transition-all duration-300 group-hover/nested:text-[var(--accent-light)] p-2">
                    {link.text}
                  </div>
                  {/* Arrow icon */}
                  <div className="text-color-1 text-base transition-all duration-300 ml-auto group-hover/nested:scale-125 opacity-70 group-hover/nested:opacity-100 mr-3 group-hover/nested:mr-2 group-hover/nested:animate-pulse group-hover/nested:text-[var(--accent-light)]">
                    <GoArrowUpRight className="w-5 h-5" />
                  </div>
                </a>
                {/* </div> */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Links;
